import { useMemo, useState, useEffect } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { useDashboard } from '../../context/DashboardContext';
import { buildKurocoSettingsData } from '../../adapters/kurocoData';
import {
  loadProfileLocal,
  loadNotifLocal,
  useGoalsConfig,
} from '../../utils/goalsLocalStore';

/** Shared hook for settings stack screens. */
export function useSettingsData() {
  const { user, logout } = useAuth();
  const {
    kpis,
    kpiHistory,
    mlForecasts,
    loading,
    selectedMonth,
    selectedStylist,
    selectedStore,
    stores,
  } = useDashboard();

  const [profileLocal, setProfileLocal] = useState(() => loadProfileLocal(user?.uid));
  const [notif, setNotif] = useState(() => loadNotifLocal(user?.uid));
  const [goals, setGoals, goalsMeta] = useGoalsConfig(user?.uid, selectedStore, selectedStylist);
  // goalsLoading matters to callers that branch on "has a goal": goals start from
  // localStorage and are replaced by the API answer, so an empty value means "not known yet"
  // until this clears.
  const {
    changeLog,
    appendChangeLogApi,
    submitActions,
    loading: goalsLoading,
    canEditGoals,
    error: goalsError,
  } = goalsMeta;

  useEffect(() => {
    setProfileLocal(loadProfileLocal(user?.uid));
    setNotif(loadNotifLocal(user?.uid));
  }, [user?.uid]);

  const D = useMemo(
    () =>
      buildKurocoSettingsData({
        kpis,
        kpiHistory,
        selectedMonth,
        loading,
        stylistName: selectedStylist,
        selectedStore,
        stores,
        goals,
        profileLocal,
        changeLog,
      }),
    [kpis, kpiHistory, selectedMonth, loading, selectedStylist, selectedStore, stores, goals, profileLocal, changeLog]
  );

  return {
    user,
    logout,
    D,
    goals,
    setGoals,
    goalsLoading,
    canEditGoals,
    goalsError,
    appendChangeLogApi,
    submitActions,
    profileLocal,
    setProfileLocal,
    notif,
    setNotif,
    kpis,
    kpiHistory,
    mlForecasts,
    loading,
    selectedMonth,
    selectedStore,
    selectedStylist,
  };
}
